<h2>DATALENGTH:{{datasize}}</h2>
<!--<prettyjson [obj]="data"></prettyjson>-->
<div *ngFor="let l of log">
    <div>{{l.firstName}}   =>  {{l.lastName}}</div>
</div>
